import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Privacidade from "@/pages/Privacidade";

export const Route = createFileRoute("/privacidade")({
  head: () => seoHead({
    title: "Privacidade & Cookies | Shopping do Bem",
    description: "Política de privacidade e cookies do Shopping do Bem.",
    path: "/privacidade",
  }),
  component: Privacidade,
});
